module.exports = __webpack_public_path__ + "img/9604a1b.jpg";